import React, { useState, useEffect } from 'react';
import { copyToClipboard } from 'utils/general';
import { create } from 'apisauce';

import { usePushSiteError } from 'hooks/usePushSiteError';
import { usePushSiteNotification } from 'hooks/usePushSiteNotification';
import APModal from 'components/Modal/APModal';

import ZapierImage from 'assets/images/zapier-card.png';

const api = create({
  baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/api-key`,
  headers: {
    'content-type': 'application/json',
    'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export const ZapierIntegration = () => {
  const [apiKey, setApiKey] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);

  const pushSiteError = usePushSiteError();
  const pushNotification = usePushSiteNotification();

  const getApiKey = () => {
    return api.get();
  };

  const getKey = async () => {
    const response = await getApiKey();

    if (response.ok) {
      setApiKey(response.data.api_key);
    }
  };

  const handleButtonClick = () => {
    if (!apiKey) generateApiKey();
    else copy();
  };

  const handleModalSubmit = () => {
    setShowWarning(false);
    setShowFollowUp(true);
    generateApiKey();
  };

  const generateApiKey = async () => {
    const response = await api.post();
    const { ok, data } = response;
    if (!ok) {
      pushSiteError('We couldn\'t generate your API key. Please try again later.');
      return;
    }
    const { api_key } = data || {};
    if (api_key) setApiKey(api_key);
  };

  const copy = () => {
    if (apiKey) {
      copyToClipboard(apiKey);
      pushNotification('Your api key has been copied.');
    }
  };

  const handleRegenerate = (e) => {
    e.preventDefault();
    setShowWarning(true);
  };

  useEffect(() => {
    getKey();
  }, []);

  return (
    <div className="integration integration--zapier">
      <div className="integration__image">
        <img src={ZapierImage} />
      </div>
      <div className="integration__content">
        <h5 className="integration__title">ZAPIER</h5>
        <p>
          Zapier is an online automation tool that allows you to instantly connect Aisle Planner with 1,000+ apps,
          such as Quickbooks and MailChimp, to automate your work and increase productivity. Getting started takes
          just a few minutes.
          <br />
          <a href="http://help.aisleplanner.com/en/articles/2664042-an-intro-to-zapier-integrations"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>.
        </p>
        {apiKey !== '' && (
          <p className="api-key">
            <strong>Your API key has been created.</strong>
            <a
              href="#"
              onClick={handleRegenerate}
            >
              Regenerate API Key
            </a>
          </p>
        )}
        {showFollowUp && (
          <p className="followup-message">
            Your prior API key has been replaced. Please update your Zapier account with the new API key.
          </p>
        )}
      </div>
      <div className="integration__actions">
        <button
          className="button"
          onClick={handleButtonClick}
        >
          {apiKey === '' ? 'Generate API Key' : 'Copy API Key'}
        </button>
      </div>
      <APModal
        open={showWarning}
        hasHeader={false}
        actions={(
          <>
            <button
              className="button button--cancel"
              onClick={() => setShowWarning(false)}
            >
              Cancel
            </button>
            <button
              className="button"
              onClick={handleModalSubmit}
            >
              Generate
            </button>

          </>
        )}
        onClose={() => setShowWarning(false)}
      >
        <p>
          Once you regenerate your API key, you'll need to update your API key in Zapier
          for integrations to continue working. Are you sure want to continue?
        </p>
      </APModal>
    </div>
  );
};
